import { SelectedFilter } from "react/pages/ReportAnalytics/schemas/report";

import request from "../base-request";

export const getUserRequiredReportingAnalyticsFilter = async (reportType: string, sharedWith: string) => {
	try {
		const url = `/api/reporting-analytics/required-reporting-analytics-filter/?report_type=${reportType}&shared_with=${sharedWith}`;

		const [data] = await request<{ subject_id_filter: SelectedFilter }>(url);

		return data?.subject_id_filter;
	} catch (error) {
		throw error;
	}
};
